__webpack_require__.p = "/wp-content/themes/empanadas-y-tamales/build/";